export default __webpack_public_path__ + "static/media/dai.db283baf.png";